import { FC, PropsWithChildren } from 'react';
import { ScBadge } from './Badge.styles';

const Badge: FC<PropsWithChildren<Record<string, unknown>>> = ({ children }) => {
  return <ScBadge>{children}</ScBadge>;
};

export default Badge;
